import {Action} from '@ngrx/store';
import {
  REQUEST_SERVICE_UPDATE, REQUEST_VIDEO_ADD, REQUEST_VIDEO_DELETE, REQUEST_VIDEO_REORDER, SET_SERVICE, VIDEO_ADD, VIDEO_DELETE,
  VIDEO_REORDER,
} from '../service/constants';
import {RequestServiceUpdateAction, SetServiceAction} from '../service/reducer';
import {ServiceUiState} from './ServiceUiState';

export const REQUEST_ERROR = '[ui] Request Error';

const initState = {
  loaders: {},
  errors: {},
};

export function serviceUiReducer (state: ServiceUiState = initState, action: Action): ServiceUiState {
  switch (action.type) {
    case REQUEST_SERVICE_UPDATE: {
      const key = (action as RequestServiceUpdateAction).payload.key;
      const loaders = {
        ...state.loaders,
        [key]: true,
      };
      return {
        ...state,
        loaders,
      };
    }
    case SET_SERVICE: {
      const key = (action as SetServiceAction).payload.field;
      return {
        ...state,
        loaders: { ...state.loaders, [key]: false },
        errors: { ...state.errors, [key]: undefined },
      };
    }
    case REQUEST_VIDEO_ADD:
    case REQUEST_VIDEO_REORDER:
    case REQUEST_VIDEO_DELETE:
      return {
        ...state,
        loaders: { ...state.loaders, videos: true },
      };
    case VIDEO_ADD:
    case VIDEO_REORDER:
    case VIDEO_DELETE:
      return {
        ...state,
        loaders: { ...state.loaders, videos: false },
        errors: { ...state.errors, videos: undefined },
      };
    case REQUEST_ERROR:
      const { errorMessage, field } = (action as RequestErrorAction).payload;
      return {
        ...state,
        errors: { ...state.errors, [field]: errorMessage },
        loaders: { ...state.loaders, [field]: false },
      };
    default:
      return state;
  }
}

export class RequestErrorAction implements Action {
  readonly type = REQUEST_ERROR;

  constructor(public payload: { errorMessage: string, field: string }) {}
}
